import Vue from 'vue';
import { MutationTree } from 'vuex';
import { ReactionState } from './state';
import { ReactionInput } from './actions';
import { westerosReactionsSource } from '@/settings/constants';

const mutations: MutationTree<ReactionState> = {
  SET_REACTIONS(state, entities: ReactionState) {
    const reactions = Object.values(entities.reactions);

    reactions.forEach((contentReaction) => {
      Vue.set(state.reactions, contentReaction.contentId, {
        ...state.reactions[contentReaction.contentId],
        ...contentReaction,
      });
    });
  },

  ADD_NEW_REACTION(state, reaction: ReactionInput) {
    if (!reaction) return;

    let contentReaction = state.reactions[reaction.contentId];

    // If there is no contentReaction, we create a new one.
    if (!contentReaction) {
      contentReaction = {
        contentId: reaction.contentId,
        source: westerosReactionsSource || '',
        reactions: [
          {
            count: 1,
            reaction: reaction.reaction,
            userReacted: true,
          },
        ],
        getters: {},
      };
    } else {
      const reactionIndex = (contentReaction.reactions || []).findIndex(
        (item) => item.reaction === reaction.reaction,
      );

      if (reactionIndex > -1) {
        contentReaction.reactions[reactionIndex].count += 1;
        contentReaction.reactions[reactionIndex].userReacted = true;
      } else {
        contentReaction.reactions.push({
          count: 1,
          reaction: reaction.reaction,
          userReacted: true,
        });
      }
    }

    Vue.set(state.reactions, contentReaction.contentId, contentReaction);
  },

  REMOVE_REACTION(state, reaction: ReactionInput) {
    if (!reaction) return;

    const contentReaction = state.reactions[reaction.contentId];

    const userReactionIndex = contentReaction.reactions.findIndex(
      (item) => item.reaction === reaction.reaction && item.userReacted,
    );

    if (userReactionIndex > -1) {
      contentReaction.reactions[userReactionIndex].count -= 1;
      contentReaction.reactions[userReactionIndex].userReacted = false;

      Vue.set(state.reactions, reaction.contentId, contentReaction);
    }
  },
};

export default mutations;
